import { handleActions } from 'redux-actions'
import {
  SET_CART_DATA, SET_CART_STATE
} from '../constants/mallConstant'
import { handleStateChange, mapObjectKey } from '../utils'

const initState = {
  loading: false,
  invalid: false,
  errorMessage: '',
  data: [],
  // 总件数 *remove
  amount: 0,
  // 总价 *remove 交由组件去计算
  total: 0
}

export const mallCart = handleActions({
  [SET_CART_STATE]: handleStateChange,
  [SET_CART_DATA]: (state, action) => {
    const { payload = [] } = action
    let amount = 0
    let total = 0
    let data = payload.map(item =>
      // id互换之术， 跟productDetails的key统一
      mapObjectKey(item, {
        id: 'index',
        lianShuoProductId: 'productId',
        productId: 'id'
      }))
    // let data = payload.map(item => {
    //  这个index，修改购物车时要传的key
    //   let {
    //     id: index, productId: id,
    //     lianShuoProductId: productId,
    //     state: checked,
    //     productCount: a,
    //     currentPrice: unit,
    //     productName: name,
    //     ...other
    //   } = item
    //   a = Number(a)
    //   unit = Number(unit)
    //   checked = `${checked}`
    //   if (checked === '1' && !Number.isNaN(a) && !Number.isNaN(unit)) {
    //     amount += a
    //     total += (a * unit)
    //   }
    //
    //   return {
    //     index,
    //     id,
    //     productId,
    //     checked,
    //     amount: a,
    //     currentPrice: unit,
    //     name,
    //     ...other
    //   }
    // })

    return {
      ...state,
      data,
      amount,
      total,
      loading:false
    }

  }
}, initState)
